import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatSelectChange } from '@angular/material/select';

interface SelectOption { value: string; label: string; }

@Component({
  selector: 'app-select-renderer',
  template: `
    <mat-select
  [disableOptionCentering]="true"
  class="plain-select"
  [value]="value"
  [compareWith]="compareFn"
  (selectionChange)="onSelectionChange($event)"
  disableRipple
  panelClass="custom-select-panel"
>
  <mat-option *ngFor="let option of parsedOptions" [value]="option.value">
    {{ option.label }}
  </mat-option>
</mat-select>
  `,
  styles: [`
    .plain-select {
      border: none;
      background: transparent;
      padding: 0 4px;
      margin: 0;
      width: 100%;
      height: 100%;
      font: inherit;
      line-height: inherit;
      cursor: pointer;
      transition: background-color 0.15s ease-in-out;
    }
    ::ng-deep .plain-select .mat-mdc-select-trigger { padding: 0 !important; }
    ::ng-deep .plain-select .mat-mdc-select-arrow { display: none !important; }
    ::ng-deep .plain-select .mat-mdc-select-value { padding: 0 !important; }
    .select-viewport { height: 200px; }
    ::ng-deep .custom-select-panel .mat-mdc-select-panel { max-height: 250px !important; }
  `]
})
export class CustomSelectAgridInputComponent implements ICellRendererAngularComp, AfterViewInit {
  params: any;
  value: any;
  parsedOptions: SelectOption[] = [];

  constructor(private cdr: ChangeDetectorRef) {
  }

  agInit(params: any): void {
    this.params = params;
    this.value = this.clean(params.value);
    this.parsedOptions = Array.isArray(params.options)
      ? params.options.map((o: any) => {
          if (o && typeof o === 'object' && o.value != null) {
            return { value: String(o.value), label: String(o.label ?? o.value) };
          }
          const v = String(this.parseValue(o));
          return { value: v, label: v };
        })
      : [];
  }

  parseValue(value: any): string {
    if (typeof value === 'string' && /^".*"$/.test(value)) {
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    }
    return value;
  }

  clean(value: any): string {
    return typeof value === 'string' ? value.trim() : value;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.value = this.params?.value;
      this.cdr.detectChanges();
    });
  }

  refresh(params: any): boolean {
    this.value = params.value;
    this.cdr.detectChanges();
    return true;
  }

  onSelectionChange(event: MatSelectChange) {
    this.value = event.value;
    if (this.params?.node?.setDataValue) {
      this.params.node.setDataValue(this.params.colDef.field, this.value);
    }
    if (this.params?.onValueChanged) {
      this.params.onValueChanged(event.value, this.params);
    }
  }

  compareFn = (a: any, b: any) => a === b || String(a) === String(b);
}
